<script>
import ApiClient from '../utils/ApiClient'

export default {
  data () {
    return {
      users: []
    }
  },
  /**
   * アーティストIDからアーティスト情報を取得する
   * @param artistId アーティストID
   * @param transactionId トランザクションID
   **/
  findArtist: function (artistId, transactionId, callback, errorHandler) {
    console.log(artistId)
    var targetPath = 'ajax/artist.php' + '?transactionid=' + transactionId
    var param = '&artist_id=' + artistId
    ApiClient.find(targetPath, param, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('getArtistList failed')
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * アーティストIDからアーティストの楽曲を取得する
   * @param artistId アーティストID
   * @param transactionId トランザクションID
   **/
  findArtistTunes: function (artistId, transactionId, callback, errorHandler) {
    var targetPath = 'ajax/artist_products.php' + '?transactionid=' + transactionId
    var param = '&artist_id=' + artistId + '&limit=1000'
    ApiClient.find(targetPath, param, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('getArtistList failed')
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * 条件から楽曲を検索する
   * @param params formData
   **/
  getArtistList: function (transactionId, callback, errorHandler) {
    var targetPath = 'ajax/artist_list.php' + '?transactionid=' + transactionId
    ApiClient.search(targetPath, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('getArtistList failed')
      console.log(error)
      errorHandler(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services/ArtistService.vue